/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {ContactsContainer, Container, FilesContainer, Title} from './styles';
import Row from 'components/Grid/Row';
import Col from 'components/Grid/Col';
import CheckBox from "components/Form/CheckBox";
import Label from 'components/Form/Label';
import Icon from 'components/Icon/index';
import {ModalSearchContact} from 'components/index';
import Colors from "../../constants/Colors";

function PartiesGrid({
                       parties,
                       setParties,
                       type,
                       handleSelect,
                       selectedItems,
                       files,
                       sendFiles,
                       setSendFiles,
                       newFile,
                       setNewFile,
                       hasContactsParties
                     }) {
  const [showModalParties, setShowModalParties] = useState([]);
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [partiesContacts, setPartiesContacts] = useState([]);


  const getTitle = () => {
    switch (type) {
      case 'client':
        return 'Client:';
      case 'insurer':
        return 'Insurer:';
      case 'third-party':
        return '3rd PARTY:';
      case 'external-broker':
        return 'External Broker:';
      default:
        return '';
    }
  }

  const handleFiles = () => {
    if (!parties.length || !files.length) return;

    if (hasContactsParties) return

    const filesWithNullIdPersons = files.filter((file) => !file.idPerson);

    for (const party of parties) {      

      if (sendFiles.some((file) => file.idPerson === party.idPersonInsurer)) {
        if (!newFile) continue;
        if (newFile.idPerson !== party.idPersonInsurer) continue;
        const partyFile = sendFiles.find((file) => file.idPerson === party.idPersonInsurer);
        partyFile.files = [...partyFile.files, newFile];
        const filteredSendFiles = sendFiles.filter((file) => file.idPerson !== party.idPersonInsurer);
        setSendFiles([...filteredSendFiles, partyFile]);
        setNewFile(null);
        continue;
      }

      const filteredFiles = files.filter(
        (file) => file.idPerson === party.idPersonInsurer || file.idPersonRoot === party.idPersonInsurer
      );

      const combinedFiles = type === 'client'
        ? [...filesWithNullIdPersons, ...filteredFiles]
        : filteredFiles;

      setSendFiles((prevFiles) => [...prevFiles, {
        idPerson: party.idPersonInsurer,
        idPersonRoot: party.idPersonInsurer,
        files: combinedFiles
      }])
    }

    setShowModalParties(parties.map((party) => ({
      idPersonInsurer: party.idPersonInsurer,
      showModal: false
    })));
  }

  useEffect(() => {
    handleFiles();
  }, [parties, files, type]);


  const isCheckedFile = (idPerson, idDocument) => {
    const partyFile = sendFiles.find((partyFile) => partyFile.idPerson === idPerson);
    return partyFile?.files.some((file) => file?.idDocument === idDocument) || false;
  };

  const handleSelectFile = (idPerson, file) => {
    setSendFiles((prevSendFiles) =>
      prevSendFiles.map((partyFile) => {
        if (partyFile.idPerson === idPerson) {
          const isFileChecked = isCheckedFile(idPerson, file.idDocument);
          const updatedFiles = isFileChecked
            ? partyFile.files.filter((f) => f.idDocument !== file.idDocument)
            : [...partyFile.files, file];

          return {
            ...partyFile,
            files: updatedFiles,
          };
        }
        return partyFile;
      })
    );
  };

  const handleSaveNewContact = (idParty, idContact) => {
    if (idContact !== '') {
      const updatedParties = parties.map((party) => {

        const contact = party.contacts.find((c) => c.idContact === idContact);
        if (contact) {
          contact.tempContact = true;
        }
        if (party.idPersonInsurer === idParty) {
          const contacts = party.contacts.map((c) => {
            if (c.idContact === idContact) {
              c.tempContact = true;
            }
            return c
          })
          return {
            ...party,
            contacts: contacts
          }
        } else {
          return party
        }
      })
      setParties(updatedParties)
    } else {
      throw new Error('The "Full Name" field is required.');
    }
  }

  const showModal = (idPersonInsurer) => {
    return showModalParties.find((party) => party.idPersonInsurer === idPersonInsurer)?.showModal
  }

  // verifica se o contato esta presente na lista de to ou cc
  const checkifIsDisabled = (idContact, type) => {
    if (type === 'to') {
      return selectedItems.to.some((selected) => selected.idContact === idContact);
    }
    if (type === 'cc') {
      return selectedItems.cc.some((selected) => selected.idContact === idContact);
    }
    return false
  }

  const handleShowModal = (idPersonInsurer) => {
    const show = showModal(idPersonInsurer);

    setShowModalParties((prevShowModalParties) => {
      return prevShowModalParties.map((party) => {
        if (party.idPersonInsurer === idPersonInsurer) {
          return {...party, showModal: !show};
        }
        return party;
      });
    });
  }

  if (!parties.length) return null;


  return parties.map((party, index) => {

    //verifica se contato esta presente no selected items
    for (const contact of party.contacts) {
      if (selectedItems.to.some((selected) => selected.idContact === contact.idContact)) {
        contact.tempContact = true;
      }
      if (selectedItems.cc.some((selected) => selected.idContact === contact.idContact)) {
        contact.tempContact = true;
      }
    }

    const filteredContacts = party.contacts.filter((contact) => contact.isOperationTeam || contact.tempContact === true);
    const initialSearchList = party?.contacts.filter((contact) => !contact.isOperationTeam && !contact.tempContact);

    return (
      <>
        <Container key={`${party}-${index}`}>
          <ModalSearchContact
            show={showModal(party.idPersonInsurer)}
            setShowModal={() => handleShowModal(party.idPersonInsurer)}
            initialSearchList={initialSearchList}
            idParty={party.idPersonInsurer}
            handleSaveNewContact={handleSaveNewContact}
          />
          <ContactsContainer>
            <Row style={{width: "100%", display: 'flex', justifyContent: 'space-between', marginBottom: 20}}>
              <Col md={12} style={{flexDirection: "row", display: "flex", paddingLeft: 0}}>
                <Title>{getTitle()} {party.insurerFirstName}</Title>
              </Col>
            </Row>
            <Row style={{width: "100%", display: 'flex', justifyContent: 'space-between', marginBottom: 20}}>
              <Col md={2} style={{flexDirection: "row", display: "flex"}}>
                <Title>Contact</Title>
              </Col>
              <Col md={2} style={{flexDirection: "row", display: "flex"}}>
                <Title>Job Title</Title>
              </Col>
              <Col md={2} style={{flexDirection: "row", display: "flex"}}>
                <Title>E-mail</Title>
              </Col>
              <Col md={2} style={{flexDirection: "row", display: "flex"}}>
                <Title>Team</Title>
              </Col>
              <Col md={2} style={{flexDirection: "row", display: "flex"}}>
                <Title>Group/Region</Title>
              </Col>
              <Col md={1} style={{flexDirection: "row", display: "flex"}}>
                <Title style={{marginLeft: 5}}>TO</Title>
              </Col>
              <Col md={1} style={{flexDirection: "row", display: "flex"}}>
                <Title style={{marginLeft: 5}}>CC</Title>
              </Col>
            </Row>
            {filteredContacts?.length ? (
                <>
                  {filteredContacts.map((contact, index) => (
                    <Row key={index}
                         style={{
                           width: "100%", display: 'flex', justifyContent: 'space-between', marginBottom: 20,
                           paddingBottom: 5, paddingTop: 5,
                         }}>
                      <Col md={2} style={{flexDirection: "row", display: "flex"}}>
                        <Label>{contact.nameContact}</Label>
                      </Col>
                      <Col md={2} style={{flexDirection: "row", display: "flex", alignItems: "start"}}>
                        <Label>{contact.jobTitle}</Label>
                      </Col>
                      <Col md={2} style={{flexDirection: "row", display: "flex", alignItems: "start"}}>
                        <Label>{contact.email}</Label>
                      </Col>
                      <Col md={2} style={{flexDirection: "row", display: "flex", alignItems: "start"}}>
                        <Label>{contact.teamName}</Label>
                      </Col>
                      <Col md={2} style={{flexDirection: "row", display: "flex", alignItems: "start"}}>
                        <Label>{!contact.mainGroups?.length ? "" : contact.mainGroups?.length === 1 ? contact.mainGroups[0] : contact.mainGroups.join("; ")}</Label>
                      </Col>
                      <Col md={1}>
                        <label>
                          <CheckBox
                            onChange={() => handleSelect(contact, party, false, type)}
                            checked={!!selectedItems.to?.find(item => item.idContact === contact.idContact)}
                            disabled={checkifIsDisabled(contact.idContact, 'cc')}
                          />
                        </label>
                      </Col>
                      <Col md={1}>
                        <label>
                          <CheckBox
                            onChange={() => handleSelect(contact, party, true, type)}
                            checked={!!selectedItems.cc?.find(item => item.idContact === contact.idContact)}
                            disabled={checkifIsDisabled(contact.idContact, 'to')}
                          />
                        </label>
                      </Col>
                    </Row>
                  ))}
                </>
              )
              : null
            }
            {!filteredContacts?.length && (
              <Row style={{flexDirection: "row", display: "flex", margin: "10px 0px 5px 15px"}}>
                <Label>No results found.</Label>
              </Row>
            )}
            <Row style={{width: "100%", display: 'flex', justifyContent: 'space-between'}}>
              <Col md={3} style={{flexDirection: "row", display: "flex"}}/>
              <Col md={2} style={{flexDirection: "row", display: "flex"}}/>
              <Col md={3} style={{flexDirection: "row", display: "flex"}}/>
              <Col md={2} style={{flexDirection: "row", display: "flex"}}/>
              <Col md={1} style={{flexDirection: "row", display: "flex"}}>
                <Icon
                  onClick={() => handleShowModal(party.idPersonInsurer)}
                  name="plus"
                />
              </Col>
            </Row>
          </ContactsContainer>

          <FilesContainer>
            <Row style={{marginTop: 40}}>
              <Col style={{flexDirection: "row", display: "flex", paddingLeft: 0}}>
                <Title>Attachments</Title>
              </Col>
            </Row>

            {files?.map((file, index) => {
              const isFileValid = type === "client"
                ? !file.idPerson || file.idPerson === party.idPersonInsurer || file.idPersonRoot === party.idPersonInsurer
                : file.idPerson === party.idPersonInsurer || file.idPersonRoot === party.idPersonInsurer;

              if (!isFileValid) return null;

              return (
                <Row key={index} style={{
                  marginBottom: 20,
                  paddingBottom: 5,
                  paddingTop: 5
                }}>
                  <Col
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center", // Centraliza verticalmente

                      paddingLeft: 0,
                      flexWrap: 'nowrap',
                      width: '100%'
                    }}
                  >
                    <label style={{display: "flex", alignItems: "center", marginRight: '10px'}}>
                      <CheckBox
                        onChange={() => handleSelectFile(party.idPersonInsurer, file)}
                        checked={isCheckedFile(party.idPersonInsurer, file.idDocument)}
                      />
                    </label>
                    <Label>
                      {file.title}
                    </Label>
                    <a href={file.lnkAccessPdf || file.fileUrl || file.url} target='_blank' style={{ marginLeft: '10px' }}>
                        <Icon name="search" />
                      </a>
                  </Col>

                </Row>
              );
            })}
          </FilesContainer>
        </Container>
        <br/>
      </>
    )
  });
}

PartiesGrid.propTypes = {
  parties: PropTypes.arrayOf(PropTypes.shape({
    insurerFirstName: PropTypes.string,
    contacts: PropTypes.arrayOf(PropTypes.shape({
      nameContact: PropTypes.string,
      personContactDepartment: PropTypes.string,
      email: PropTypes.string,
      legalEntity: PropTypes.string
    })),
    idPersonInsurer: PropTypes.number
  })),
  type: PropTypes.oneOf(['client', 'insurer', 'third-party', 'external-broker']),
  handleSelect: PropTypes.func,
  selectedItems: PropTypes.shape({
    to: PropTypes.arrayOf(PropTypes.shape({
      email: PropTypes.string
    })),
    cc: PropTypes.arrayOf(PropTypes.shape({
      email: PropTypes.string
    }))
  }),
  files: PropTypes.arrayOf(PropTypes.shape({
    idPerson: PropTypes.number,
    idPersonRoot: PropTypes.number,
    title: PropTypes.string
  })),
  newFile: PropTypes.shape({
    idPerson: PropTypes.number,
    idPersonRoot: PropTypes.number,
    title: PropTypes.string
  }),
  setNewFile: PropTypes.func,
};

PartiesGrid.defaultProps = {
  parties: [],
  type: '',
  handleSelect: () => {
  },
  selectedItems: {to: [], cc: []},
  files: [],
  newFile: null,
  setNewFile: () => {
  },
};

export default PartiesGrid;
